@use '../../scss/utility';
@use './card-style-api';

// Todo remove with V8.0.0 and assign component tokens directly
:host {
  --bg-color--hover: var(--card-bg-color-hover);
  --bg-color: var(--card-bg-color);
  --border-color--hover: var(--card-indicator-color-hover);
  --border-color--pressed: var(--card-border-color-pressed);
  --border: var(--card-border);
  --color: var(--card-text-color);
  --shadow: var(--card-shadow);
}

:host {
  display: block;
  background: var(--bg-color);
  box-shadow: var(--shadow);
  color: var(--color);
  border: var(--border);
  position: relative;
  border-radius: var(--border-radius);
}

.indicator {
  content: '';
  position: absolute;
  inset-block-end: utility.wb-pixel-to-rem(-1px);
  inset-inline: utility.wb-pixel-to-rem(-1px);
  height: utility.wb-pixel-to-rem(2px);
  background: var(--border-color--hover);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s var(--wb-fade);

  @media (prefers-reduced-motion) {
    transition: transform 0s;
  }
}

:host([interactive]:hover) {
  cursor: pointer;
  background: var(--bg-color--hover);

  .indicator {
    transform: scaleX(1);
  }
}

:host([interactive]:active) {
  background: var(--bg-color--active);

  .indicator {
    transform: scaleX(1);
    background-color: var(--border-color--pressed);
  }
}

:host([interactive]:focus) {
  outline: utility.wb-pixel-to-rem(1px) solid var(--border-color--hover);

  .indicator {
    transform: scaleX(1);
  }
}

:host([is-rtl][interactive]) {
  .indicator {
    transform-origin: right;
  }
}
